import axios from 'axios';

const url = process.env.VUE_APP_RBAPI;

const getInstitution = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');
    
    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
        if (!access_token)
        {
            var query = window.location.hash
            .slice(2)
            .split('&')
            .filter(function(param) {
                return !!param;
            })
            .reduce(function(memo, param) {
                var keyValue = param.split('=');
                memo[keyValue[0]] = keyValue[1];
                return memo;
            }, {});

            if (query.redirect_uri) {
                localStorage.setItem('scientia-session-redirectTo', query.redirect_uri); 
            }    
      

            if (query.access_token)
            {
                let auth = "{\"access_token\":\""+query.access_token +"\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('scientia-session-authorization', auth);
                access_token = query.access_token;
            }
        }
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
   
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/InstitutionSettings/';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const getNotifications = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
        if (!access_token)
        {
            var query = window.location.hash
            .slice(2)
            .split('&')
            .filter(function(param) {
                return !!param;
            })
            .reduce(function(memo, param) {
                var keyValue = param.split('=');
                memo[keyValue[0]] = keyValue[1];
                return memo;
            }, {});

            if (query.redirect_uri) {
                localStorage.setItem('scientia-session-redirectTo', query.redirect_uri); 
            }          

            if (query.access_token)
            {
                let auth = "{\"access_token\":\""+query.access_token +"\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('scientia-session-authorization', auth);
                access_token = query.access_token;
            }
        }
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Notifications?PageNumber=1&ItemsPerPage=999&NotificationType=2&RequiresAction=true';

    let result = await axios.get(urlWithArg, headers);

    if (result.data.Count > 0) localStorage.setItem('role', 'admin')
    else
        localStorage.setItem('role', 'user')
        
    return result.data;

}

const operateStatus = async function (url){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url;

    let result = await axios.post(urlWithArg, '', headers);
    
    return result.data;

}

const operateStatusByID = async function (id, status){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    let urlWithArg = url + 'api/Notifications/'+id+'/'+status;

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };

    let result = await axios.post(urlWithArg, '', headers);
    
    return result.data;

}



export const baseService = { getInstitution, getNotifications, operateStatus, operateStatusByID}


// WEBPACK FOOTER //
// ./src/api/base-service.js